import "./TextLine.less";

export function TextLine({ children }: { children?: string }) {
    return <span className="TextLine gux-label">{children}</span>;
}
